exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dpsVCModule {\n  height: 100%; }\n\n.restore-datagrid .datagrid .datagrid-select .datagrid-column-title {\n  display: none; }\n\n.out-of-place-wizard .clr-wizard .tree-container .spinner {\n  position: relative;\n  top: auto;\n  left: auto; }\n\n.out-of-place-wizard .clr-wizard .tree-container .tree-node-expanded > .toggle-children {\n  transform: none !important; }\n\n.policy-secondary-block {\n  padding-left: 5px; }\n  .policy-secondary-block .form-group {\n    padding-left: 30px; }\n    .policy-secondary-block .form-group .retetion-block {\n      width: 100%; }\n      .policy-secondary-block .form-group .retetion-block .row #retention {\n        width: 100%; }\n\n.privilege-error-class {\n  text-align: center;\n  padding: 48px;\n  font-size: 18px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/dataprotection-vc.scss
// module id = MYmp
// module chunks = 0